import { render, staticRenderFns } from "./BaseSwitchTheme.vue?vue&type=template&id=b39a9c36&scoped=true&"
import script from "./BaseSwitchTheme.vue?vue&type=script&lang=js&"
export * from "./BaseSwitchTheme.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwitchTheme.vue?vue&type=style&index=0&id=b39a9c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39a9c36",
  null
  
)

export default component.exports